import { useState, useEffect, useRef } from 'react';
import { Form, FormInstance } from 'antd';

export default function useFormSubmittable(form: FormInstance): boolean {
  const [submittable, setSubmittable] = useState<boolean>(true);
  const formValues = Form.useWatch(null, form);
  const formFieldKeys = Object.keys(form.getFieldsValue()).join(','); // Forcer une revalidation lorsque des champs ont été ajoutés ou bien supprimés du formulaire
  const currentFormValidationPromise = useRef(Promise.resolve());

  useEffect(() => {
    let newValidationPromise = form.validateFields({ validateOnly: true });
    const setFunc = (newSubmittable: boolean) => () => {
      // Ne modifier l'état submittable que si aucune autre validation n'a été lancée entre temps
      if (currentFormValidationPromise.current === newValidationPromise) {
        setSubmittable(newSubmittable);
      }
    };
    newValidationPromise = newValidationPromise.then(setFunc(true));
    newValidationPromise = newValidationPromise.catch(setFunc(false));
    currentFormValidationPromise.current = newValidationPromise;
  }, [form, formValues, formFieldKeys]);

  return submittable;
}
